export default __webpack_public_path__ + "static/maitakehover-5972636f98144ff01a1676687dde3ba3.png";